<template>
  <el-dialog title="方案充值"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="400px">

    <el-form :model="bfm" ref="bfm" size="small" label-width="80px" label-position="right">
      <el-form-item label="公司名称:" prop="userId">
        <el-select v-model="bfm.companyId" @change="onSelectedScheme" placeholder="请选择公司名称">
          <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="方案名称:" prop="schemeId">
        <el-select v-model="bfm.schemeId" placeholder="请选择方案">
          <el-option
              v-for="item in schemeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值数量:" prop="price">
        <el-input-number v-model="bfm.amount" min="1" max="100000" placeholder="请输入充值数量" style="width:100%;"></el-input-number>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="save()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>

  </el-dialog>

</template>

<script>
  import {findAllList} from '@/api/manage/company'
  import {save} from '@/api/manage/recharge'
  import {findAllScheme} from '@/api/manage/program'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      visible: false,
      companyId: null
    },
    computed: {
      ...mapGetters(['user']),
    },
    data() {
      return {
        companyList: [],
        schemeList: [],
        bfm: {
          amount: 100,
        },
      };
    },
    methods: {
      init() {
        this.getCompanyList()
        if(this.companyId){
          this.onSelectedScheme(this.companyId)
        }
      },
      getCompanyList() {
        findAllList().then(res => {
          this.companyList = res.data.result || []
          if(this.companyId){
            this.$set(this.bfm,'companyId',this.companyId*1)
          }
        }).then(()=>{
          //this.companyList.filter(c=>c.id === this.companyId)[0]
        })
      },
      onSelectedScheme(companyId) {
        findAllScheme(companyId).then(res => {
          let data = res.data.result
          let list = [...data.persons, ...data.standards]
          this.schemeList = list
        })
      },
      save() {
        this.$refs['bfm'].validate((valid) => {
          if (valid) {
              this.bfm.acceptorId = this.user.id;
              save(this.bfm).then(resp => {
                this.$message.success("充值成功!")
                this.$emit('done', true)
              })
            }
        });
      },
      doClose(){
        this.$emit('done', false)
      }
    }
  }
</script>

